<div class="privacy">
  <div class="row">
    <div class="col-md-3 col-lg-4 col-xl-3 index">
      <ul>
        @for (item of sections; track item.id; let i = $index) {
          <li>
            <a
              [routerLink]="[]"
              [fragment]="item.id"
              [class.select]="activeIndex === i"
              (click)="activeIndex = i"
            >
              {{ item.label | translate }}
            </a>
          </li>
        }
      </ul>
    </div>
    <div class="col-md-12 col-lg-8 col-xl-9 content" id="content">
      <div id="privacy" #section>
        <h2>{{ 'privacy.sections.privacy.title' | translate }}</h2>
        <p>{{ 'privacy.sections.privacy.description1' | translate }}</p>
        <p>{{ 'privacy.sections.privacy.description2' | translate }}</p>
        <p>{{ 'privacy.sections.privacy.description3' | translate }}</p>
        <p>{{ 'privacy.sections.privacy.description4' | translate }}</p>
      </div>
      <div id="information" #section>
        <h2>{{ 'privacy.sections.information.title' | translate }}</h2>
        <p>{{ 'privacy.sections.information.description1' | translate }}</p>
      </div>
      <div id="typesOfDataCollected" #section>
        <h2>{{ 'privacy.sections.typesOfDataCollected.title' | translate }}</h2>
        <h3>{{ 'privacy.sections.typesOfDataCollected.personalData.title' | translate }}</h3>
        <p>{{ 'privacy.sections.typesOfDataCollected.personalData.description1' | translate }}</p>
        <ul>
          <li>
            <p>{{ 'privacy.sections.typesOfDataCollected.personalData.dot1' | translate }}</p>
          </li>
          <li>
            <p>{{ 'privacy.sections.typesOfDataCollected.personalData.dot2' | translate }}</p>
          </li>
          <li>
            <p>{{ 'privacy.sections.typesOfDataCollected.personalData.dot3' | translate }}</p>
          </li>
          <li>
            <p>{{ 'privacy.sections.typesOfDataCollected.personalData.dot4' | translate }}</p>
          </li>
          <li>
            <p>{{ 'privacy.sections.typesOfDataCollected.personalData.dot5' | translate }}</p>
          </li>
        </ul>
        <h3>{{ 'privacy.sections.typesOfDataCollected.usageData.title' | translate }}</h3>
        <p>{{ 'privacy.sections.typesOfDataCollected.usageData.description1' | translate }}</p>
        <h3>
          {{ 'privacy.sections.typesOfDataCollected.trackingAndCookiesData.title' | translate }}
        </h3>
        <p>
          {{
            'privacy.sections.typesOfDataCollected.trackingAndCookiesData.description1' | translate
          }}
        </p>
        <p>
          {{
            'privacy.sections.typesOfDataCollected.trackingAndCookiesData.description2' | translate
          }}
        </p>
        <p>
          {{
            'privacy.sections.typesOfDataCollected.trackingAndCookiesData.description3' | translate
          }}
        </p>
        <p>
          {{
            'privacy.sections.typesOfDataCollected.trackingAndCookiesData.examplesTitle' | translate
          }}
        </p>
        <ul>
          <li>
            <p>
              {{
                'privacy.sections.typesOfDataCollected.trackingAndCookiesData.example1' | translate
              }}
            </p>
          </li>
          <li>
            <p>
              {{
                'privacy.sections.typesOfDataCollected.trackingAndCookiesData.example2' | translate
              }}
            </p>
          </li>
          <li>
            <p>
              {{
                'privacy.sections.typesOfDataCollected.trackingAndCookiesData.example3' | translate
              }}
            </p>
          </li>
        </ul>
      </div>
      <div id="useOfData" #section>
        <h2>{{ 'privacy.sections.useOfData.title' | translate }}</h2>
        <p>{{ 'privacy.sections.useOfData.description1' | translate }}</p>
        <ul>
          <li>
            <p>{{ 'privacy.sections.useOfData.dot1' | translate }}</p>
          </li>
          <li>
            <p>{{ 'privacy.sections.useOfData.dot2' | translate }}</p>
          </li>
          <li>
            <p>{{ 'privacy.sections.useOfData.dot3' | translate }}</p>
          </li>
          <li>
            <p>{{ 'privacy.sections.useOfData.dot4' | translate }}</p>
          </li>
          <li>
            <p>{{ 'privacy.sections.useOfData.dot5' | translate }}</p>
          </li>
          <li>
            <p>{{ 'privacy.sections.useOfData.dot6' | translate }}</p>
          </li>
          <li>
            <p>{{ 'privacy.sections.useOfData.dot7' | translate }}</p>
          </li>
        </ul>
      </div>
      <div id="transferOfData" #section>
        <h2>{{ 'privacy.sections.transferOfData.title' | translate }}</h2>
        <p>{{ 'privacy.sections.transferOfData.description1' | translate }}</p>
        <p>{{ 'privacy.sections.transferOfData.description2' | translate }}</p>
        <p>{{ 'privacy.sections.transferOfData.description3' | translate }}</p>
        <p>{{ 'privacy.sections.transferOfData.description4' | translate }}</p>
      </div>
      <div id="disclosureOfData" class="visually-hidden" #section>
        <h2>{{ 'privacy.sections.disclosureOfData.title' | translate }}</h2>
        <p>{{ 'privacy.sections.disclosureOfData.description1' | translate }}</p>
      </div>
      <div id="legalRequirements" #section>
        <h2>{{ 'privacy.sections.legalRequirements.title' | translate }}</h2>
        <p>{{ 'privacy.sections.legalRequirements.description1' | translate }}</p>
        <ul>
          <li>{{ 'privacy.sections.legalRequirements.dot1' | translate }}</li>
          <li>{{ 'privacy.sections.legalRequirements.dot2' | translate }}</li>
          <li>{{ 'privacy.sections.legalRequirements.dot3' | translate }}</li>
          <li>{{ 'privacy.sections.legalRequirements.dot4' | translate }}</li>
          <li>{{ 'privacy.sections.legalRequirements.dot5' | translate }}</li>
        </ul>
      </div>
      <div id="securityOfData" #section>
        <h2>{{ 'privacy.sections.securityOfData.title' | translate }}</h2>
        <p>{{ 'privacy.sections.securityOfData.description1' | translate }}</p>
      </div>
      <div id="serviceProviders" #section>
        <h2>{{ 'privacy.sections.serviceProviders.title' | translate }}</h2>
        <p>{{ 'privacy.sections.serviceProviders.description1' | translate }}</p>
        <p>{{ 'privacy.sections.serviceProviders.description2' | translate }}</p>
      </div>
      <div id="linksToOtherSites" #section>
        <h2>{{ 'privacy.sections.linksToOtherSites.title' | translate }}</h2>
        <p>{{ 'privacy.sections.linksToOtherSites.description1' | translate }}</p>
        <p>{{ 'privacy.sections.linksToOtherSites.description2' | translate }}</p>
      </div>
      <div id="childrensPrivacy" #section>
        <h2>{{ 'privacy.sections.childrensPrivacy.title' | translate }}</h2>
        <p>{{ 'privacy.sections.childrensPrivacy.description1' | translate }}</p>
        <p>{{ 'privacy.sections.childrensPrivacy.description2' | translate }}</p>
      </div>
      <div id="changesToThisPrivacyPolicy" #section>
        <h2>{{ 'privacy.sections.changesToThisPrivacyPolicy.title' | translate }}</h2>
        <p>{{ 'privacy.sections.changesToThisPrivacyPolicy.description1' | translate }}</p>
        <p>{{ 'privacy.sections.changesToThisPrivacyPolicy.description2' | translate }}</p>
        <p>{{ 'privacy.sections.changesToThisPrivacyPolicy.description3' | translate }}</p>
      </div>
      <div id="contactUs" #section>
        <h2>{{ 'privacy.sections.contactUs.title' | translate }}</h2>
        <p>{{ 'privacy.sections.contactUs.description1' | translate }}</p>
        <ul>
          <li>{{ 'privacy.sections.contactUs.dot1' | translate }}</li>
        </ul>
      </div>
    </div>
  </div>
</div>
